import { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import CommentSection from "../components/CommentSection"; 
import NewsDetailComp from "../components/NewsDetailComp"; // ✅ Reusable Component
import { getNewsBySlug } from "../services/newsService"; // ✅ API Call Function
import { postComment } from "../services/newsService"; // ✅ API Call Function
import { getUserIdFromToken } from "../services/authService"; // ✅ Import function
import Layout from "../pages/Layout";
import { Helmet, HelmetProvider } from "react-helmet-async";

const NewsDetail = () => {
  const { slug } = useParams(); // ✅ Get news Slug from URL
  const [news, setNews] = useState(null);
  const [loading, setLoading] = useState(true);
  const [message, setMessage] = useState("");
  const userId = getUserIdFromToken; // ✅ Dummy User ID (Replace with real user ID)

  useEffect(() => {
    // Scroll to the top when the component is mounted
    window.scrollTo(0, 0);
    
    fetchNewsDetail();
  }, [slug]); // ✅ Ensure re-fetch on ID change

  const fetchNewsDetail = async () => {
    setLoading(true);
    try {
      const response = await getNewsBySlug(slug);
      if (response.success) {
        setNews(response.newsData);
      } else {
        setNews(null);
      }
    } catch (error) {
      console.error("Error fetching news:", error);
      setNews(null);
    }
    setLoading(false);
  };

  const handleComments = async (formData) => {
      setLoading(true);
      setMessage("");
  
      try {
        const result = await postComment(formData); // ✅ Use your Axios-based addnews function
        if (result.success) {
          setMessage(result.message);
        } else {
          setMessage(result.message);
        }
      } catch (error) {
        setMessage(error || "Error connecting to the server.");
      }
  
      setLoading(false);
    };

  return (
    <div className="news-detail-container">
      <HelmetProvider>
      <Helmet>
  <title>{news?.title ? news.title :"Stay updated with the latest news, breaking headlines, business insights, entertainment, and more at Factbazaar"}</title>
  <meta name="description" content={news?.description ? news.description :"Stay updated with the latest news, breaking headlines, business insights, entertainment, and more at Factbazaar."} />
  <meta name="keywords" content= {news?.meta ? news.meta : "latest news, breaking news, business news, entertainment news, world news, Factbazaar"}  />
  <meta name="author" content="Factbazaar Team" />
  <meta property="og:title" content={news?.title ? news.title :"Stay updated with the latest news, breaking headlines, business insights, entertainment, and more at Factbazaar"} />
  <meta property="og:description" content={news?.description ? news.description :"Stay updated with the latest news, breaking headlines, business insights, entertainment, and more at Factbazaar."} />
  <meta property="og:type" content="article" />
  <meta property="og:url" content={`https://factbazaar.com/${news?.category ?? ""}/${news?.slug ?? ""}`} />
  <meta property="og:image" content= {news?.imagePath ? news.imagePath : "https://factbazaar.com/logo.png"} />
</Helmet>
</HelmetProvider>
      <Layout>
      
      
      { loading ? 
          <div className="text-center py-3">
          <div className="spinner-border text-primary" role="status">
            <span className="visually-hidden">Loading...</span>
          </div>
        </div> : 
          <NewsDetailComp news={news}  onSubmit={handleComments} loading={loading}/>
          }

      {/* ✅ Add Comment Section */}
      {/* {news && <CommentSection comments={news.comments} />} */}
      </Layout>
    </div>
  );
};

export default NewsDetail;
